import { useState } from 'react';

const defaultConfig = {
    activeTabIndex: 0,
};

export function useTabs(config = {}) {
    const settings = { ...defaultConfig, ...config };
    const [activeTabIndex, setActiveTab] = useState(settings.activeTabIndex);

    const selectTabFn = (index: number) => {
        if (index !== activeTabIndex) {
            setActiveTab(index);
        }
    };

    return {
        activeTabIndex,
        selectTabFn,
    };
}

export default useTabs;
